import { render, staticRenderFns } from "./st-tournamentInfo.vue?vue&type=template&id=f0d12296&"
import script from "./st-tournamentInfo.vue?vue&type=script&lang=js&"
export * from "./st-tournamentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports